export default __webpack_public_path__ + "static/media/background-3.1a5f7825.png";